import { HStack, Flex } from "@chakra-ui/react";
import PlusIcon from "@root/assets/icons/plusicon";
import { useTranslation } from "react-i18next";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DownloadIcon } from "@root/assets/icons/downloadIcon";
import { ROUTE_NAMES } from "@root/constants";
import { CommonButton } from "@root/components/common/button";
import ModelDisplay from "./model-selection-toggler.tsx/model-text";
import { getChatType } from "@root/utils";
import { AttachedFilesList } from "@root/components/dashboard/AttachedFilesList";

const DocumentHeader: React.FC<any> = () => {
  const { t } = useTranslation("common");
  const { pathname } = window.location;
  const {
    attachedFile,
    setAttachedFile,
    downloadPdfOfThread,
    downloadPdfLoading,
    model,
    setModel,
  } = useMainChatContext();
  const { id } = useParams();
  const navigate = useNavigate();

  const handleDelete = (fileId: string) => {
    setAttachedFile((prev: any) => prev.filter((doc: any) => doc.id !== fileId));
  };
  const chatType = useMemo(() => {
    return getChatType(pathname);
  }, [pathname]);

  return (
    <HStack
      p={"10px 25px"}
      justifyContent={"space-between"}
      position="relative"
      spacing={5}
      overflow="visible"
      borderBottom={"1px solid #CACACA"}
    >
      <Flex gap={"10px"} minW="0" flex="1">
        <AttachedFilesList
          files={attachedFile}
          onDelete={handleDelete}
        />
        <Flex flexShrink={0}>
          <ModelDisplay modelKey={chatType} />
        </Flex>
      </Flex>
      <Flex gap={"3"}>
        {id && (
          <CommonButton
            variant="secondary"
            startIcon={<DownloadIcon />}
            onClick={() => downloadPdfOfThread({ threadId: id })}
            isLoading={downloadPdfLoading}
          >
            {t("translate.downloadAnswer")}
          </CommonButton>
        )}
        {id && (
          <CommonButton
            variant="primary"
            startIcon={<PlusIcon size={15} />}
            onClick={() => {
              navigate(ROUTE_NAMES.CHECKLIST);
            }}
          >
            {t("translate.startChat")}
          </CommonButton>
        )}
      </Flex>
    </HStack>
  );
};

export default DocumentHeader;
